export default {
    settings: {
        size: 'small',
        limit: 2,
    },
};
